import styled from "styled-components";

export const EditBranchFormStyles = styled.div`
  max-width: 960px;

  form {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[20]};
  }
`;
